import clsx from 'clsx';

export const setTransform = (el: HTMLElement, value: string): void => {
  el.style.transform = value;
  el.style.webkitTransform = value;
};

export const setTransition = (el: HTMLElement, value: string): void => {
  el.style.transition = value;
  el.style.webkitTransition = value;
};

export const prefixCls = (
  classObj: Record<string, boolean | undefined>,
  isPc?: string | boolean,
) => {
  return clsx({
    ...classObj,
    // eslint-disable-next-line @typescript-eslint/camelcase
    __linkchat_pc_render__: isPc || false,
  });
};
